import { Card } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
    min-height: 90vh;
    display: flex;
    flex-direction: column;
`;

export const StatusContainer = styled(Card)`
    padding: 20px;
    display: flex;
    flex-direction: column;
    margin: 5px;
    row-gap: 15px;
    min-height: 60px;
`;

export const CardContainer = styled(Card)`
    padding: 20px;
    display: flex;
    flex-direction: column;
    margin: 5px;
    row-gap: 15px;
`;

export const CampaignCard = styled(Card)`
    padding: 16px;
    margin-bottom: 8px;
    border-left: 4px solid ${(props) => props.$borderColor || '#ccc'};
`;
